import { useBillingServiceStore } from '@billing/AppProvider'
import { CarrierVisitDto } from '@billing/app/api'
import { Autocomplete, Box, FormControl, Stack, TextField, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { CustomInputAdornment, TruckIcon } from '@tom-ui/ui'
import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'

export const DeliveryNoteReportFilter = observer(() => {
  const { t } = useTranslate()

  const { deliveryNoteReportUIStore, reportsUIStore } = useBillingServiceStore()

  const selectedValue = deliveryNoteReportUIStore.truckVisitsOptions.find(
    x => x.id === deliveryNoteReportUIStore.selectedTruckVisit?.id,
  )

  const showError =
    reportsUIStore.nextButtonWasBlocked && !deliveryNoteReportUIStore.selectedTruckVisit

  return (
    <FormControl sx={{ width: '350px' }}>
      <Autocomplete
        options={deliveryNoteReportUIStore.truckVisitsOptions}
        value={selectedValue ?? null}
        onChange={(event: any, newValue: CarrierVisitDto | null) => {
          deliveryNoteReportUIStore.setSelectedTruckVisit(newValue)
        }}
        getOptionLabel={option => option.carrierName ?? ''}
        fullWidth
        renderInput={params => (
          <TextField
            {...params}
            label={t('truckVisit', 'Truck visit')}
            required
            error={showError}
            helperText={
              showError
                ? `${t('truckVisit', 'Truck visit')} ${t('isMandatory', 'is mandatory')}`
                : undefined
            }
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <CustomInputAdornment position='start'>
                  <TruckIcon viewBox='0 0 20 14' sx={{ width: 18 }} />
                </CustomInputAdornment>
              ),
            }}
          />
        )}
        renderOption={(props, option) => (
          <Box component='li' {...props} key={option.id}>
            <Stack>
              <Typography variant='subtitle1'>{option.carrierName}</Typography>

              <Stack direction='row' gap={theme => theme.customSpacing.xxs}>
                <Typography variant='caption' color='secondary'>
                  {t('ata', 'ATA')}:
                </Typography>
                <Typography variant='caption' color='secondary'>
                  {option.ata ? dayjs(option.ata).format('L LT') : '-'}
                </Typography>
              </Stack>
            </Stack>
          </Box>
        )}
      />
    </FormControl>
  )
})
